import { render, staticRenderFns } from "./SingleShippingOrder.vue?vue&type=template&id=2c7d81fe&scoped=true"
import script from "./SingleShippingOrder.vue?vue&type=script&lang=js"
export * from "./SingleShippingOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleShippingOrder.vue?vue&type=style&index=0&id=2c7d81fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d81fe",
  null
  
)

export default component.exports